// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// Pure data-shaping helpers for combining WaniKani /subjects and /assignments
// responses into a lookup keyed by the kanji character itself, which is what
// KanaLearn's own kanji pages (joyoKanji, kanjiDetails, ...) are keyed by.

export function buildProgressByKanji(subjects, assignments) {
    const subjectById = new Map(
        subjects.map((subject) => [
            subject.id,
            { characters: subject.data.characters, level: subject.data.level },
        ])
    );

    const progressByKanji = {};

    for (const assignment of assignments) {
        const subject = subjectById.get(assignment.data.subject_id);
        if (!subject || !subject.characters) continue;

        progressByKanji[subject.characters] = {
            srsStage: assignment.data.srs_stage,
            level: subject.level,
            unlockedAt: assignment.data.unlocked_at,
            passedAt: assignment.data.passed_at,
            burnedAt: assignment.data.burned_at,
            subjectId: assignment.data.subject_id,
        };
    }

    return progressByKanji;
}
